import EA from '../helpers/init';
import { Swiper } from 'swiper';
import { Pagination, Navigation } from 'swiper/modules';

export default EA.Methods.swiper2 = ($this) => {
    const swiper = $this.querySelector('.swiper2');
    const nextBtn = $this.querySelector('.blog-detail-next-slide');
    const prevBtn = $this.querySelector('.blog-detail-last-slide');

    const containerWidth = 1440;
    const pagePadding = 40;

    if (!swiper) return;

    const gallerySwiper = new Swiper(swiper, {
        modules: [
            Pagination,
            Navigation,
        ],

        navigation: {
            nextEl: nextBtn,
            prevEl: prevBtn,
        },

        speed: 1050,
        slidesPerView: 1.05,
        spaceBetween: 24,
        breakpoints: {
            600: {
                slidesPerView: 'auto',
                spaceBetween: 32,
            },
        },

        centerInsufficientSlides: true,
        watchOverflow: true,
        watchSlidesProgress: true,


        // Bitno: nemoj loop za keyboard focus
        loop: true,

        // Ako želiš da strelice i dalje mogu vrtjeti kraj -> početak
        // bez loop duplicate slideova:
        rewind: true,
    });

    gallerySwiper.slides.forEach((slide, index) => {
        slide.addEventListener('focusin', () => {
            gallerySwiper.slideTo(index);
        });
    });

    swiper.addEventListener('keydown', (event) => {
        if (event.key !== 'Enter' && event.key !== ' ') return;

        const item = event.target.closest('.item');

        if (!item || !swiper.contains(item)) return;

        event.preventDefault();
        item.click();
    });
};